import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/seo-data";

const footerGuides = [
  { name: "Poradnik 2026", slug: "artykul/usfansspreadsheet-poradnik-2026" },
  { name: "Jak zacząć", slug: "artykul/usfansspreadsheet-jak-zaczac-2026" },
  { name: "Funkcje", slug: "artykul/usfansspreadsheet-funkcje-2026" },
  { name: "Integracje", slug: "artykul/usfansspreadsheet-integracje-2026" },
  { name: "FAQ", slug: "artykul/usfansspreadsheet-faq-2026" },
];

const footerTutorials = [
  { name: "Recenzja 2026", slug: "artykul/usfansspreadsheet-recenzja-2026" },
  { name: "Bezpieczeństwo", slug: "artykul/usfansspreadsheet-bezpieczenstwo-2026" },
  { name: "Porównanie", slug: "artykul/usfansspreadsheet-porownanie-2026" },
  { name: "Opinie", slug: "artykul/usfansspreadsheet-opinie-2026" },
  { name: "Aktualizacje", slug: "artykul/usfansspreadsheet-aktualizacje-2026" },
];

const footerCategories = categories.slice(0, 6);

export default function Footer() {
  const { t } = useTranslation("common");

  return (
    <footer className="bg-background-200 py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="bg-background-50 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                  <i className="ri-grid-line text-background-50 text-sm"></i>
                </div>
                <span className="text-base font-heading font-semibold text-foreground-950">
                  USFansSpreadsheet
                </span>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">
                USFansSpreadsheet to kompleksowe źródło informacji, poradników i recenzji. Naszym celem jest dostarczanie najbardziej aktualnych i rzetelnych informacji.
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-950 text-white hover:bg-foreground-800 transition-colors cursor-pointer"
                >
                  <i className="ri-shopping-bag-line text-sm"></i>
                </a>
              </div>
            </div>

            {/* Guides */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                {t("guides")}
              </h4>
              <ul className="space-y-2.5">
                {footerGuides.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={`/${item.slug}`}
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Reviews */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                {t("reviews")}
              </h4>
              <ul className="space-y-2.5">
                {footerTutorials.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={`/${item.slug}`}
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Categories */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                {t("categories")}
              </h4>
              <ul className="space-y-2.5">
                {footerCategories.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between mt-8 pt-6 border-t border-background-300/60">
          <p className="text-xs text-foreground-400">
            &copy; 2026 USFansSpreadsheet. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-4 mt-3 sm:mt-0">
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-600 transition-colors">
              Polityka prywatności
            </span>
            <span className="text-foreground-300">|</span>
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-600 transition-colors">
              Regulamin
            </span>
            <Link
              to="/artykul/usfansspreadsheet-poradnik-2026"
              className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer"
            >
              Poradnik
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}